export enum BankAccountType {
    SAVINGS = 'SAVINGS',
    CURRENT = 'CURRENT',
    FIXED_DEPOSIT = 'FIXED_DEPOSIT',
    TAX_FREE_DEPOSIT = 'TAX_FREE_DEPOSIT',
    HIGH_YIELD_SAVINGS = 'HIGH_YIELD_SAVINGS',
    ONLINE_SAVINGS = 'ONLINE_SAVINGS',
}

export const BankAccountTypeOptions = [
    { label: 'บัญชีออมทรัพย์ — Savings Account', value: BankAccountType.SAVINGS },
    { label: 'บัญชีกระแสรายวัน — Current Account', value: BankAccountType.CURRENT },
    { label: 'บัญชีเงินฝากประจำ — Fixed Deposit Account', value: BankAccountType.FIXED_DEPOSIT },
    { label: 'บัญชีเงินฝากปลอดภาษี — Tax-Free Deposit Account', value: BankAccountType.TAX_FREE_DEPOSIT },
    { label: 'บัญชีเงินฝากออมทรัพย์พิเศษ — High-Yield Savings Account', value: BankAccountType.HIGH_YIELD_SAVINGS },
    { label: 'บัญชีเงินฝากออนไลน์ — Online Savings Account', value: BankAccountType.ONLINE_SAVINGS },
];


export interface Bank {
    name: string
    fullname: string
    nameEN: string
    symbol: string
    icon: string
    color: string
}

export interface BankList {
    [key: string]: Bank
}



export const bankListArray = [
    {
        name: "กสิกรไทย",
        fullname: "ธนาคารกสิกรไทย",
        nameEN: "Kasikorn Bank",
        symbol: "KBANK",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/KBANK.png",
        color: "#1DA858"
    },
    {
        name: "ไทยพาณิชย์",
        fullname: "ธนาคารไทยพาณิชย์",
        nameEN: "The Siam Commercial Bank",
        symbol: "SCB",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/SCB.png",
        color: "#543186"
    },
    {
        name: "กรุงไทย",
        fullname: "ธนาคารกรุงไทย",
        nameEN: "Krungthai Bank",
        symbol: "KTB",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/KTB.png",
        color: "#1DA8E6"
    },
    {
        name: "กรุงเทพ",
        fullname: "ธนาคารกรุงเทพ",
        nameEN: "Bangkok Bank",
        symbol: "BBL",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/BBL.png",
        color: "#29449D"
    },
    {
        name: "กรุงศรีอยุธยา",
        fullname: "ธนาคารกรุงศรีอยุธยา",
        nameEN: "Krungsri Bank",
        symbol: "BAY",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/BAY.png",
        color: "#FFD51C"
    },
    {
        name: "ทีเอ็มบีธนชาต",
        fullname: "ธนาคารทีเอ็มบีธนชาต",
        nameEN: "TMBThanachart Bank",
        symbol: "TTB",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/TTB.png",
        color: "#0C55F2"
    },
    {
        name: "ยูโอบี",
        fullname: "ธนาคารยูโอบี",
        nameEN: "United Overseas Bank",
        symbol: "UOB",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/UOB.png",
        color: "#E41A26"
    },
    {
        name: "เกียรตินาคิน",
        fullname: "ธนาคารเกียรตินาคินภัทร",
        nameEN: "Kiatnakin Phatra Bank",
        symbol: "KKP",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/KKP.png",
        color: "#5A547C"
    },
    {
        name: "ออมสิน",
        fullname: "ธนาคารออมสิน",
        nameEN: "Government Savings Bank",
        symbol: "GSB",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/GSB.png",
        color: "#ED1891"
    },
    {
        name: "ธ.ก.ส.",
        fullname: "ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร",
        nameEN: "Bank for Agriculture and Agricultural Cooperatives",
        symbol: "BAAC",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/BAAC.png",
        color: "#CCA41C"
    },
    {
        name: "ซีไอเอ็มบี",
        fullname: "ธนาคารซีไอเอ็มบี",
        nameEN: "CIMB Thai Bank",
        symbol: "CIMB",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/CIMB.png",
        color: "#BD1325"
    },
    {
        name: "ซิตี้แบงก์",
        fullname: "ธนาคารซิตี้แบงก์",
        nameEN: "citibank",
        symbol: "CITI",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/CITI.png",
        color: "#0F3D89"
    },
    {
        name: "ธ.อ.ส.",
        fullname: "ธนาคารอาคารสงเคราะห์",
        nameEN: "GH Bank",
        symbol: "GHB",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/GHB.png",
        color: "#FF8614"
    },
    {
        name: "เอชเอสบีซี",
        fullname: "ธนาคารเอชเอสบีซี",
        nameEN: "HSBC Bank",
        symbol: "HSBC",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/HSBC.png",
        color: "#FF1518"
    },
    {
        name: "อิสลามแห่งประเทศไทย",
        fullname: "ธนาคารอิสลามแห่งประเทศไทย",
        nameEN: "Islamic Bank of Thailand",
        symbol: "IBANK",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/IBANK.png",
        color: "#164626"
    },
    {
        name: "ไอซีบีซี",
        fullname: "ธนาคารไอซีบีซี",
        nameEN: "ICBC Thai Commercial Bank",
        symbol: "ICBC",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/ICBC.png",
        color: "#CD1511"
    },
    {
        name: "แลนด์ แอนด์ เฮ้าส์",
        fullname: "ธนาคารแลนด์ แอนด์ เฮ้าส์",
        nameEN: "LH Bank",
        symbol: "LHB",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/LHB.png",
        color: "#727375"
    },
    {
        name: "ไทยเครดิต",
        fullname: "ธนาคารไทยเครดิต",
        nameEN: "Thai Credit Bank",
        symbol: "TCRB",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/TCRB.png",
        color: "#FF7813"
    },
    {
        name: "ทิสโก้",
        fullname: "ธนาคารทิสโก้",
        nameEN: "Tisco Bank",
        symbol: "TISCO",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/TISCO.png",
        color: "#267CBC"
    },
    {
        name: "พร้อมเพย์",
        fullname: "พร้อมเพย์",
        nameEN: "PromptPay",
        symbol: "PromptPay",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/PromptPay.png",
        color: "#0C4370"
    },
    {
        name: "ทรูมันนี่",
        fullname: "ทรูมันนี่",
        nameEN: "True Money",
        symbol: "TrueMoney",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/TrueMoney.png",
        color: "#EE252B"
    }
];